export const ACCESS_TOKEN = "access_token";
export const TOKEN_TYPE = "bearer";
export const REFRESH_TOKEN = "refreshToken";